import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import ImageWithBasePath from "../../../components/Common/imageWithBasePath";
import { forgetPassword } from "../../../services/authService";
import { message } from "antd";

const ForgetPassword: React.FC = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {   
      const response = await forgetPassword(email);
      if (response.success) {
        message.success(t("password_email_sent"));
        setEmail("");
      } else {
        message.error(t("error_occurred"));
      }
    } catch (error) {
      message.error(t("error_occurred"));
      console.error("Password reset failed:", error);
    }
  };

  return (
    <div className="container">
      <div
        className="row justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <div className="col-md-5">
          <form onSubmit={handleSubmit} className="px-3 py-4">
            {/* Logo */}
            <div className="text-center mb-3">
              <ImageWithBasePath
                src="assets/img/authentication/logo-1.webp"
                className="mw-100"
                alt="Logo"
                width={400}
              />
            </div>

            {/* Forget Password Card */}
            <div className="card">
              <div className="card-body p-4">
                <div className="mb-4 text-center">
                  <h2 className="mb-2">{t("forgot_password")}</h2>
                  <p className="mb-0">{t("enter_email_to_reset")}</p>
                </div>

                <div className="mb-3">
                  <label className="form-label">{t("email_address")}</label>
                  <div className="input-icon mb-3 position-relative">
                    <span className="input-icon-addon"></span>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="form-control"
                      placeholder={t("enter_email")}
                      required
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <button type="submit" className="btn btn-primary w-100">
                    {t("reset_password")}
                  </button>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="text-center mt-3">
              <p className="mb-0">
                {t("copyright")} © {new Date().getFullYear()} - Schoolation
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
